import api from './api';
import type { WineList, PaginatedResponse } from '../types/venue';

const base = (venueId: string) => `/admin/venue/${venueId}/wine-list`;

const wineListService = {
  /** Get all wine lists for a venue. */
  getWineLists: async (
    venueId: string,
    page = 1,
    pageSize = 20,
    type?: string,
    status?: string,
  ): Promise<PaginatedResponse<WineList>> => {
    const params: Record<string, unknown> = { page, pageSize };
    if (type) params.type = type;
    if (status) params.status = status;
    const response = await api.get(base(venueId), { params });
    return response.data;
  },

  /** Get a single wine list. */
  getWineList: async (venueId: string, wineListId: string): Promise<WineList> => {
    const response = await api.get(`${base(venueId)}/${wineListId}`);
    return response.data;
  },

  /** Create a wine list. */
  createWineList: async (
    venueId: string,
    data: Omit<WineList, '_id' | 'venueId' | 'createdAt' | 'updatedAt'>
  ): Promise<WineList> => {
    const response = await api.post(base(venueId), data);
    return response.data;
  },

  /** Update a wine list. */
  updateWineList: async (
    venueId: string,
    wineListId: string,
    data: Partial<Omit<WineList, '_id' | 'venueId' | 'createdAt' | 'updatedAt'>>
  ): Promise<WineList> => {
    const response = await api.put(`${base(venueId)}/${wineListId}`, data);
    return response.data;
  },

  /** Archive (soft-delete) a wine list. */
  deleteWineList: async (venueId: string, wineListId: string): Promise<void> => {
    await api.delete(`${base(venueId)}/${wineListId}`);
  },
};

export default wineListService;
